<a *ngIf="customer_model" class="grid-link" [routerLink]="['/customer', customer_model.id]">{{ text }}</a>
